<template>
  <t-container class="py-6 px-4 md:px-0 md:py-20">
    <h2
      v-if="header === true"
      class="pb-2 text-center"
    >
      Reviews from Our Satisfied Therapists
    </h2>
    <div
      id="trustbox"
      class="trustpilot-widget"
      data-locale="en-US"
      data-template-id="539adbd6dec7e10e686debee"
      data-businessunit-id="5919c6120000ff0005a27e57"
      data-style-height="600px"
      data-style-width="100%"
      data-stars="4,5"
      :data-tags="tag"
    >
      <a
        href="https://www.trustpilot.com/review/summit-education.com"
        target="_blank"
      >Trustpilot</a>
    </div>
  </t-container>
</template>

<script>
export default {
  name: 'TrustPilotReviews',
  props: {
    header: {
      type: Boolean,
      default: true,
    },
    tag: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const trustbox = document.getElementById('trustbox');
    window.Trustpilot?.loadFromElement(trustbox);
  },
};
</script>
